import { useEffect, useRef } from 'react';

interface Props {
  assetCode?: string;
  options?: { code?: string; name?: string; value?: string }[];
  setValue: (code: string) => void;
  isDisabled?: boolean;
}

export const useOperationsPreSelectAsset = ({
  assetCode,
  options,
  setValue,
  isDisabled,
}: Props) => {
  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current || isDisabled) return;

    if (!assetCode) {
      isInitialized.current = true;
      return;
    }

    if (options?.length === 0 || !setValue) return;

    const foundAsset = options?.find(
      asset =>
        asset?.code === assetCode ||
        asset?.name === assetCode ||
        asset?.value === assetCode
    );

    if (foundAsset) {
      isInitialized.current = true;
      setValue(assetCode);
    }
  }, [assetCode, options, setValue, isDisabled]);
};
